import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';

class SiteStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'SITE_CHANGE_EVENT';
        const NAME = 'SITE_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        this.loading = true;
        this.sites = [];
        this.currentSite = null;
        this.count = 0;
    }

    isLoading() {
        return this.loading;
    }

    getSites() {
        return this.sites;
    }

    setSites(sites) {
        this.sites = sites;
    }

    setCount(count) {
        this.count = count;
    }

    deleteSite(id) {
        this.sites = this.sites.filter(a => a.id !== id);
    }

    addSite(site) {
        this.sites.push(site);
        this.sites = this.sites.sort((a,b) => a.name > b.name ? 1 : b.name > a.name ? -1 : 0).slice(0);
    }

    updateSite(options, id) {
        this.sites = this.sites.map(s => {
            if (s.id === id) {
                for (const prop in options) {
                    s[prop] = options[prop];
                }
            }

            return s;
        }).sort((a,b) => a.name > b.name ? 1 : b.name > a.name ? -1 : 0);
    }

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        case Constants.LOGOUT:
            this._initStore();
            this._emitChange();
            break;
        case Constants.SITES_GET_START:
            this.loading = true;
            this._emitChange();
            break;
        case Constants.SITES_GET_END:
            this.loading = false;
            this.setSites(action.value.sites);
            this.setCount(action.value.count);
            this._emitChange();
            break;
        case Constants.SITE_ADDED:
            this.addSite(action.value);
            this._emitChange();
            break;
        case Constants.SITE_UPDATED:
            this.updateSite(action.value.options, action.value.id);
            this._emitChange();
            break;
        case Constants.SITE_DELETED:
            this.deleteSite(action.value.id);
            this._emitChange();
            break;
        default:
            return false;
        }
    }

}

export default new SiteStore();
